var React = require("react");
const createReactClass = require('create-react-class');
const PropTypes = require('prop-types');

var Modal = createReactClass({
	propTypes: {
		show: PropTypes.bool,
		keyboard: PropTypes.bool,
		closeHandler: PropTypes.func,
		className: PropTypes.string,
		closeTitle: PropTypes.string,
		options: PropTypes.array,
		large: PropTypes.bool
	},

	getDefaultProps: function() {
		return {
			show: true,
			keyboard: true,
			closeHandler: () => {},
			className: "",
			large: false,
			options: []
		};
	},

	componentDidMount: function() {
		this.modal({show: this.props.show, keyboard: this.props.keyboard});
	},

	componentWillUnmount: function() {
		this.modal('hide');
	},

	getCloseTitle: function() {
		return {__html: this.props.closeTitle};
	},

	modal: function(options) {
		var selector = $(this.selector);
		selector.modal(options);
		selector.on('hidden.bs.modal', function() {
			this.props.closeHandler();
		}.bind(this));
	},

	selector: null,

	render: function() {
		let classNames = 'modal';
		let dialogClassNames = 'modal-dialog';

		if (this.props.large) {
			dialogClassNames += ' modal-lg';
		}

		if (this.props.className) {
			classNames += ' ' + this.props.className;
		}

		let options = null;
		if (this.props.options && this.props.options.length) {
			options = (
				<li className="dropdown">
					<a href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						Options<i className="fa fa-caret-down"></i>
					</a>
					<ul className="dropdown-menu dropdown-menu-right">
						{this.props.options.map(function(item) {
							let icon = null;
							if (item.icon !== "") {
								icon = (
									<i className={"icon " + item.icon} aria-hidden="true"></i>
								);
							}
							return (
								<li key={item.title}>
									<a href="javascript:void(0)" onClick={item.handler}>{icon}{item.title}</a>
								</li>
							);
						})}
					</ul>
				</li>
			);
		}

		return (
			<div className={classNames} ref={function(node) { this.selector = node; }.bind(this)}>
				<div className={dialogClassNames}>
					<div className="modal-content">
						<div className="modal-header">
							<ul className="nav nav-tabs">
								{options}
								<li>
									<a href="javascript:void(0)" className="close" data-dismiss="modal" dangerouslySetInnerHTML={this.getCloseTitle()} />
								</li>
							</ul>
							<h4 className="modal-title">{this.props.title}</h4>
						</div>
						<div className="modal-body">
							{this.props.children}
						</div>
					</div>
				</div>
			</div>
		);
	}
});

module.exports = Modal;
